import { Tooltip, Typography } from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';
import { TooltipContent } from 'src/types';

type Props = {
  description?: TooltipContent['key'];
  label: string;
};

const TableHeadLabel: React.FC<Props> = ({ label, description }) => {
  if (description) {
    return (
      <Tooltip border="light" title={description} detailed>
        <Typography variant="subtitle2">{label}</Typography>
      </Tooltip>
    );
  }

  return <Typography variant="subtitle2">{label}</Typography>;
};

export default memo(TableHeadLabel);
